module.exports = __webpack_public_path__ + "static/media/webBg.de02c1e7.png";